import { TableHead } from './TableHead';
import { Pagination } from './Pagination';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Api_Url } from "../../../../utils/ApiUrl";
import Loader from '../../../../hooks/loader';
import { formatDecimal } from '../../../../utils/formatDecimal';
import ReactPaginate from 'react-paginate';
import { useCreditIssued } from '../../../../hooks/Refund/useCreditIssued';

function CreditIssued({ startDate, endDate }) {
    const {
        issuedTransactions,
        loading,
        error,
        page,
        pageCount,
        totalItems,
        itemsPerPage,
        handlePageChange,
        startItem,
        endItem
    } = useCreditIssued(startDate, endDate);

    return (
        <>
        
            {loading && <Loader/>}
            <div className="table-responsive ">
                <table className="table">
                  <TableHead/>
                    <tbody>
                        {issuedTransactions?.map((transaction) => (
                            <tr key={transaction._id}>
                                <td>
                                    <div className="twice-text">
                                        <h6>{new Date(transaction?.createdAt).toLocaleDateString('en-IL', { timeZone: 'Asia/Jerusalem' })}</h6>
                                        <p>{new Date(transaction?.createdAt).toLocaleTimeString('en-IL', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' })}</p>
                                    </div>
                                </td>
                                <td>                                        <p className="codepara text-capitalize">{transaction?.country || 'N/A'}</p>
</td> {/* Data not available in the API response */}
                                <td>
                                    <a
                                        href={`https://etherscan.io/tx/${transaction?.transactionHash}`} // Assuming it's an Ethereum transaction
                                        className="codepara"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {transaction?.transactionHash?.slice(0, 7)}...{transaction?.transactionHash?.slice(-3)}
                                        {transaction?.transactionHash && <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 15 15"
                                            fill="none"
                                            cursor="pointer"
                                        >
                                            <path
                                                d="M5.97629 3.41683H4.92629C4.2729 3.41683 3.94595 3.41683 3.69639 3.54399C3.47687 3.65584 3.29852 3.83419 3.18667 4.05371C3.05951 4.30327 3.05951 4.63022 3.05951 5.28361V9.71694C3.05951 10.3703 3.05951 10.6969 3.18667 10.9464C3.29852 11.166 3.47687 11.3446 3.69639 11.4565C3.94571 11.5835 4.27226 11.5835 4.92437 11.5835H9.36131C10.0134 11.5835 10.3395 11.5835 10.5888 11.4565C10.8083 11.3446 10.9873 11.1658 11.0991 10.9463C11.2262 10.6969 11.2262 10.3707 11.2262 9.71863V8.66683M11.8095 5.75016V2.8335M11.8095 2.8335H8.89284M11.8095 2.8335L7.72618 6.91683"
                                                stroke="#77868B"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>}
                                    </a>
                                </td>
                                <td>
                                    <p className="codepara">
                                        {transaction?.by?.slice(0, 7)}...{transaction?.by?.slice(-3)}
                                      <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 15 15"
                                            fill="none"
                                            cursor="pointer"
                                            onClick={() => {
                                                navigator.clipboard.writeText(transaction?.by);
                                            }}
                                        >
                                            <path
                                                d="M10.1281 7.99972L10.1545 10.4496C10.1765 12.4911 9.36866 13.3165 7.32711 13.3385L4.87726 13.3649C2.83571 13.3869 2.0103 12.5791 1.98831 10.5375L1.96193 8.08766C1.93995 6.04611 2.74777 5.2207 4.78932 5.19871L7.23918 5.17233C9.28073 5.15035 10.1061 5.95817 10.1281 7.99972Z"
                                                stroke="#77868B"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M13.5902 4.46213L13.6166 6.91198C13.6386 8.95353 12.8308 9.77895 10.7892 9.80093L10.1476 9.80784L10.1281 7.99961C10.1061 5.95806 9.28071 5.15024 7.23917 5.17222L5.43094 5.19169L5.42403 4.55006C5.40204 2.50851 6.20987 1.6831 8.25142 1.66112L10.7013 1.63474C12.7428 1.61275 13.5682 2.42058 13.5902 4.46213Z"
                                                stroke="#77868B"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </p>
                                </td>
                                <td>
                                    <div className="maintoken">
                                        {transaction.privateSale  && (
                                            <div className="tokenimg">
                                                <img
                                                    src={`/assets/${transaction?.privateSale.toLowerCase()}.svg`}                                                    alt="innerimg"
                                                    className="innerimg"
                                                />
                                            </div>
                                        )}
                                        <p className="tokenpara">{transaction.privateSale}</p>
                                    </div>
                                </td>
                                <td>{formatDecimal(transaction.creditRefunded) }</td>
                                <td>{transaction.wasPremium ? 'True' : '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="footer-content">
               <Pagination   startItem={startItem} endItem={endItem} totalItems={totalItems} pageCount={pageCount} handlePageChange={handlePageChange} page={page}  />
            </div> 
        </>
    );
}

export default CreditIssued;